module.exports = __webpack_public_path__ + "static/AmericanDreamSmall-4fd1ab8a072680447f28dbf52bc08da7.jpg";